module.exports = __webpack_public_path__ + "static/entrepreneur@3x-f74d100f603a1e8547196687f9faca0d.png";